import Uid from './Uid';

const globals = {
  qlik: null,
  resize: null,
};

export default { Uid, globals };